module.exports = __webpack_public_path__ + "static/media/INJ.b1fdbc02.svg";